import React, { useEffect, useState } from "react";
import { X, Clock } from "lucide-react";
import { OFFER } from "../mock";

// Last-chance $179 reminder shown when a visitor moves to leave the page.
export const ExitIntentPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("descent_exit_shown")) return;

    const trigger = () => {
      if (sessionStorage.getItem("descent_exit_shown")) return;
      setOpen(true);
      sessionStorage.setItem("descent_exit_shown", "1");
    };

    // Desktop: cursor leaves the top of the viewport
    const onMouseOut = (e) => {
      if (e.clientY <= 0 && !e.relatedTarget) trigger();
    };

    // Mobile: quick upward scroll near the top (back-to-search behaviour)
    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      if (lastY - y > 40 && y < 260) trigger();
      lastY = y;
    };

    document.addEventListener("mouseout", onMouseOut);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      document.removeEventListener("mouseout", onMouseOut);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const goBook = () => {
    setOpen(false);
    const el = document.getElementById("quiz-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-brand-ink/70 p-4 backdrop-blur-sm animate-fade-in"
      onClick={() => setOpen(false)}
    >
      <div
        className="relative w-full max-w-md overflow-hidden rounded-3xl bg-brand-ivory p-8 text-center shadow-2xl ring-1 ring-brand-cream"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => setOpen(false)}
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full text-brand-muted transition hover:bg-brand-cream hover:text-brand-ink"
          aria-label="Close"
        >
          <X size={18} />
        </button>

        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-brand-sage/10">
          <Clock className="text-brand-sage" size={26} />
        </div>

        <p className="mt-5 font-sans text-xs font-semibold uppercase tracking-[0.2em] text-brand-golddark">
          Wait — don't miss this
        </p>
        <h3 className="mt-3 font-serif text-3xl leading-tight text-brand-ink">
          Your {OFFER.name} spot is still open
        </h3>
        <p className="mt-3 font-sans text-sm text-brand-muted">
          Lock it in for just{" "}
          <span className="font-semibold text-brand-sage">${OFFER.price}</span>{" "}
          <span className="text-brand-muted line-through">${OFFER.regPrice}</span> before this
          week's spots fill up. No surgery, no needles, no downtime.
        </p>

        <button
          onClick={goBook}
          className="mt-7 w-full rounded-full bg-brand-sage px-8 py-4 font-sans text-sm font-semibold uppercase tracking-[0.14em] text-brand-ivory shadow-[0_10px_30px_-8px_rgba(46,69,57,0.6)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-sagedark"
        >
          Claim My ${OFFER.price} Spot
        </button>
        <button
          onClick={() => setOpen(false)}
          className="mt-3 font-sans text-xs text-brand-muted underline underline-offset-4 transition hover:text-brand-ink"
        >
          No thanks, maybe later
        </button>
      </div>
    </div>
  );
};
